// Local storage helpers for resumable chunked uploads.
const CHUNKED_UPLOAD_STORAGE_PREFIX = "chunked-upload:";

const getChunkedUploadKey = (seriesId, file, instanceUid) => {
  const name = file?.name || "file";
  const size = file?.size || 0;
  return `${CHUNKED_UPLOAD_STORAGE_PREFIX}${seriesId}:${instanceUid ||
    name}:${name}:${size}`;
};

const loadChunkedSession = key => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const saveChunkedSession = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // ignore storage errors
  }
};

const clearChunkedSession = key => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // ignore storage errors
  }
};

export {
  clearChunkedSession,
  getChunkedUploadKey,
  loadChunkedSession,
  saveChunkedSession
};
